/** Takes in value of hour in as whole numbers (example 0 for 12AM), returns hours in AM/PM (example 12 AM)  */
export const hourFormat = (hourInNumber: number): string => {
  const strHour = hourInNumber.toString();
  if (parseInt(strHour) === 0) return '12 AM';
  else if (0 < parseInt(strHour) && parseInt(strHour) < 12)
    return `${strHour} AM`;
  else if (parseInt(strHour) === 12) return '12 PM';
  else return `${parseInt(strHour) - 12} PM`;
};
